<div class="header-wrapper">
  <h2>Calentadores pendientes de auditoría</h2>
  @if (count > 0) {
    <span class="badge">{{ count }} Pendientes</span>
  }
</div>
